import {Flyout} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {AboutYouLogo} from '../../AboutYouLogo/AboutYouLogo';
import {DOLInfoBody} from './DOLInfoBody';

export const DOLInfoBottomSheet = ({
  isOpen,
  showItemNumberArrow,
  showTrackingNumberArrow,
  onClose,
}: {
  isOpen: boolean;
  showTrackingNumberArrow?: boolean;
  showItemNumberArrow?: boolean;
  onClose: VoidFunction;
}) => {
  return (
    <Flyout
      open={isOpen}
      data-testid="DeclarationOfLossInfo"
      onClose={onClose}
      headerContent={
        <AboutyouLogoWrapper>
          <AboutYouLogo />
        </AboutyouLogoWrapper>
      }
      bodyContent={
        <DOLInfoBody
          showItemNumberArrow={showItemNumberArrow}
          showTrackingNumberArrow={showTrackingNumberArrow}
          isMobile
        />
      }
    />
  );
};

const AboutyouLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 8px 0;
`;
